<template lang="pug">
	.content-static-pages(v-if="dataReady")
		.inside
			h3: | We offer two levels of service:
			ul
				li: | traditional and excellent
					router-link.contextual-link(to='/full-service')
						span: | &nbsp;Full Service&nbsp;
					| for both Residential and Commercial projects.
				li: | convenient and quick web-based
					router-link.contextual-link(to='/do-it-yourself')
						span: | &nbsp;Do-it-Yourself Service&nbsp;
					| for Residential Projects only.
			h3: | Full Service Price Schedule
			p: | Our full service prices vary according to the characteristics of each project. Please use our
				router-link(to='/compliance-wizard') &nbsp;Cost Estimator “wizard”
				| &nbsp;to determine the scope and type of project you have, and our basic fee options.
			p: | For Commercial Outdoor Lighting Projects please
				router-link.contextual-link(to='contact-us')
					span: | &nbsp;contact us&nbsp;
				| with the characteristics of your project.
			h3: | Do-It-Yourself Price Schedule
			p: | Do-It-Yourself prices assume that you register as a member on our site, and that you 'take off' the information from your design yourself using the EasyTitle24 Takeoff Tools. Registering an account and using our takeoff tools is free, subject to our
				router-link.contextual-link(to='/terms-and-conditions')
					span: | &nbsp;Terms and conditions.
			p: | You may use the EasyTitle24 Takeoff Tools as long as you need to enter the information on your project. You only get charged when you submit your project for one of the Base Services below.

			div(v-for="cat in categories")
				h3 {{ cat.name }}
				table(class="table table-striped" )
					tbody
						tr.price-tr(v-for="(prodSku, index) in cat.products")
							th(scope="col") {{ findBySku(prodSku).name }}
							th(scope="col" class="th-price") $ {{ findBySku(prodSku).price }}
</template>
<script>
import Vue from 'vue'
import _ from 'lodash'

export default {
	name: 'prices-component',
	data () {
		return {
			products: [],
			dataReady: false,
			categories: [
				{
					name: 'Do-It-Yourself Base Services',
					products: [1002, 1001, 2001, 2002]
				},
				{
					name: 'Premium Options',
					products: [3001, 3002]
				},
				{
					name: 'Shipping Options',
					products: [4001, 4002, 5001, 5003, 5002]
				}
			]
		}
	},
	created () {
		Vue.e24Common.productService.findAll().then((products) => {
			console.log('product loaded', products)
			this.products = products
			this.products = _.map(this.products, (prod) => {
				prod.price = prod.price.toFixed(2)
				return prod
			})
			this.dataReady = true
		})
	},
	methods: {
		findBySku (sku) {
			return _.find(this.products, { sku: sku.toString() })
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/resources/content-prices.vue